module.exports = __webpack_public_path__ + "assets/img/empty-state-groups-full.18dfd228.svg";